import supabase from './supabase'

/**
 * Saves an email address using the store_email function in Supabase
 * @param {string} email - The email address to save
 * @returns {Promise<Object>} - The result of the operation
 */
export const saveEmailToSupabase = async (email) => {
  try {
    // Call the store_email function in Supabase
    const { data, error } = await supabase.rpc('store_email', {
      email_address: email,
    })

    if (error) {
      console.error('Error saving email to Supabase:', error)
      return { success: false, error }
    }

    return { success: true, data }
  } catch (error) {
    console.error('Exception when saving email to Supabase:', error)
    return { success: false, error }
  }
}

/**
 * Saves sponsor contact form data to the patrocinadores_contacto table in Supabase
 * @param {Object} formData - The form data to save
 * @returns {Promise<Object>} - The result of the operation
 */
export const saveSponsorContactToSupabase = async (formData) => {
  try {
    // Call the add_sponsor_contact function in Supabase
    const { data, error } = await supabase.rpc('add_sponsor_contact', {
      p_empresa: formData.companyName,
      p_persona: formData.contactPerson,
      p_email: formData.email,
      p_telefono: formData.phone,
      p_sector: formData.sector,
      p_presupuesto: formData.budget,
      p_comentarios: formData.comments,
    })

    if (error) {
      console.error('Error saving sponsor contact to Supabase:', error)
      return { success: false, error }
    }

    return { success: true, data }
  } catch (error) {
    console.error('Exception when saving sponsor contact to Supabase:', error)
    return { success: false, error }
  }
}
